<div class="mat-elevation-z8"  class="DS_Teamroster">
  <!-- <div >
  <img style="height: 40px;" src="../../assets/img{{this.TeamIcon}}" />
</div> -->
<app-text-divider DividerText="{{'PLAYER.GOALTENDERS' | translate | uppercase }}"
class="DS_Teamroster positionTitle"></app-text-divider>

@for (player of goalies; track player.LifelineScoutingId) {
  
  <app-team-roster-player [Player]="player" [GameId]="this.GameId"></app-team-roster-player>
}




<app-text-divider DividerText="{{'PLAYER.DEFENDERS' | translate | uppercase }}"
class="DS_Teamroster positionTitle"></app-text-divider>

@for (player of defenders; track player.LifelineScoutingId) {
  <app-team-roster-player [Player]="player" [GameId]="this.GameId"></app-team-roster-player>
}

<!--  <app-team-roster-player ></app-team-roster-player>  <app-team-roster-player ></app-team-roster-player>

<app-team-roster-player ></app-team-roster-player>  <app-team-roster-player ></app-team-roster-player>

<app-team-roster-player ></app-team-roster-player>  <app-team-roster-player ></app-team-roster-player>

<app-team-roster-player ></app-team-roster-player>  <app-team-roster-player ></app-team-roster-player>   -->

<app-text-divider DividerText="{{'PLAYER.FORWARDS' | translate | uppercase }}"
class="DS_Teamroster positionTitle"></app-text-divider>

@for (player of forwards; track player.LifelineScoutingId) {
  <app-team-roster-player [Player]="player" [GameId]="this.GameId"></app-team-roster-player>
}


</div>